import { Component, OnInit } from '@angular/core';
import { Module } from './module';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ModuleService } from './moduleService';

@Component({
  selector: 'app-module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.less']
})
export class ModuleComponent implements OnInit {
  modules: Module[]
  module = new Module
  private location: Location

  constructor(private http: HttpClient, private route: ActivatedRoute, private moduleservice: ModuleService) { }

  ngOnInit() {
    const id = +this.route.snapshot.paramMap.get('id');
    console.log(id);
    if (id == 0) {
      this.moduleservice.getModules().subscribe(modules => this.modules = modules);
    }
    else
      this.moduleservice.getModule(id).subscribe(module => this.module = module);

  }


  save(): void {
    console.log(this.module.module);
    this.moduleservice.updateModule(this.module)
      .subscribe();
  }

  getModuleById(id: number) {
    this.moduleservice.getModule(id).subscribe(module => this.module = module);
    console.log("the module is " + this.module);
  }
  goBack(): void {
    this.location.reload;
  }
}
